const PREFFIX = process.env.VUE_APP_BASE_API || 'vue_app_base_api'

const cacheSessionStorage = {
  set(key, value) {
    sessionStorage.setItem(`${PREFFIX}-${key}`, JSON.stringify(value))
  },
  get(key, defaultValue) {
    const item = sessionStorage.getItem(`${PREFFIX}-${key}`) || defaultValue
    let data
    try {
      data = JSON.parse(item)
    } catch (error) {
      data = defaultValue
    }
    return data
  },
  remove(key) {
    sessionStorage.removeItem(`${PREFFIX}-${key}`)
  }
}

export default cacheSessionStorage
